import { Component, Input } from '@angular/core';
import { BacklogStatus } from 'src/app/shared/model/cybersocxdr/backlogStatus';

@Component({
  selector: 'app-backlog-sanity-score',
  templateUrl: './backlog-sanity-score.component.html',
})
export class BacklogSanityScoreComponent {
  @Input()
  backlogStatus: BacklogStatus;

  getBarStyle() {
    return { width: `${this.backlogStatus?.sanityScore ?? 0}%` };
  }
}
